import React from 'react'
import { createRoot } from 'react-dom/client'
import thunk from 'redux-thunk'
import './index.css'
import App from './App'
import reducer from './reducers'
import { Provider } from 'react-redux'
import { createStore, applyMiddleware, compose } from 'redux'
import {fetchSessionId, getSavedDeviceUuid, getSavedUsername} from './utils/Prefs'

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const initialState = {
  session: {
    sessionId: fetchSessionId(),
    uuid: getSavedDeviceUuid(),
    userId: getSavedUsername()
  },
  entitlements: {
    entitlement: null
  }
}

const store = createStore(
  reducer,
  initialState,
  composeEnhancers(
    applyMiddleware(thunk)
  )
)

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

